import validators from '@/utils/validators'
import { isValidPhoneNumber } from 'react-phone-number-input'

export const inputValidations = {
  name: {
    required: 'Campo obrigatório',
    validate: (value) => validators.name(value) || 'Nome inválido'
  },
  email: {
    required: 'Campo obrigatório',
    validate: (value) => validators.email(value) || 'Email inválido'
  },
  phone: {
    required: 'Campo obrigatório',
    validate: (value) => isValidPhoneNumber(value) || 'Telefone inválido'
  },
  cpf: {
    required: 'Campo obrigatório',
    validate: (value) => validators.cpf(value) || 'CPF inválido'
  }
}
